<template>
  <b-modal @hide="modalClose" ref="materialShapeModal" :title="$t('材料')" size="xl">
    <b-container fluid>
      <table class="table table-bordered my-3">
        <tbody class="tbody">
          <tr>
            <th class="table-active text-left" width="220">
              {{ $t('材料コード') }}
              <br />
              <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
            </th>
            <td class="text-left" width="280">
              <div class="input-group w-100 position-relative">
                <input
                  v-model="form.code"
                  type="search"
                  class="form-control input"
                  :disabled="disabled"
                  @focus="mixinListToggle('materialList', true)"
                  @blur="mixinListToggle('materialList', false)"
                />
                <!-- <input v-model="form.code" type="search" class="form-control input" autocomplete="off" :disabled="disabled" @focus="mixinListToggle('productList', true)" @blur="mixinListToggle('productList', false)" /> -->
                <div class="input-group-append">
                  <button
                    class="btn btn-light h-100"
                    type="button"
                    @click="disabledRelease()"
                  >選択解除</button>
                </div>
                <div id="materialList" class="list-group searchList" style="display:none">
                  <a
                    v-for="(item,index) in filterCode"
                    :key="index"
                    @click="existMaterial(item)"
                    class="list-group-item list-group-item-action"
                  >{{ item.code }}/{{ item.name }}</a>
                </div>
              </div>
            </td>
            <th class="table-active text-left" width="280">{{ $t('材料名/材質') }}</th>
            <td class="text-left" width="260">
              <input
                v-model="form.name"
                type="text"
                class="form-control"
                :disabled="disabled"
              />
            </td>
            <th class="table-active text-left" width="200">{{ $t('RoHS指令対応') }}</th>
            <td class="text-left" width="180">
              <input
                v-model="form.isRoHS"
                type="checkbox"
                class="checkbox"
                style="transform:scale(1.4)"
                :disabled="disabled"
              />
            </td>
          </tr>
          <tr class>
            <th class="table-active text-left">{{ $t('材料寸法') }}</th>
            <td class="text-left">
              <div class="form-check form-check-inline">
                <input
                  v-model="form.shapeType"
                  @change="shapeTypeChange()"
                  class="form-check-input"
                  type="radio"
                  id="material-shapeType1"
                  value="round"
                  :disabled="disabled"
                />
                <label class="form-check-label" for="material-shapeType1">{{ $t("丸") }}</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="form.shapeType"
                  @change="shapeTypeChange()"
                  class="form-check-input"
                  type="radio"
                  id="material-shapeType2"
                  value="corner"
                  :disabled="disabled"
                />
                <label class="form-check-label" for="material-shapeType2">{{ $t("角") }}</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="form.shapeType"
                  @change="shapeTypeChange()"
                  class="form-check-input"
                  type="radio"
                  id="material-shapeType3"
                  value="plate"
                  :disabled="disabled"
                />
                <label class="form-check-label" for="material-shapeType3">{{ $t("板") }}</label>
              </div>
            </td>
            <th class="table-active text-left">{{ $t('寸法') }}</th>
            <td class="text-left" colspan="1">
              <template v-if="form.shapeType === 'round'">
                <span class="mr-2">&Phi;</span>
              </template>
              <template v-if="form.shapeType === 'plate'">
                <span class="mr-2">t</span>
              </template>
              <div class="form-check form-check-inline shapeValues">
                <template v-for="(item,index) in form.shapeValues">
                  <span :key="index">
                    <input
                      v-model.number="form.shapeValues[index]"
                      type="number"
                      class="form-control wf-80"
                      :disabled="disabled"
                    />
                  </span>
                </template>
                <span v-if="form.shapeType" class="ml-2" style="width: 23px">mm</span>
              </div>
            </td>
            <th class="table-active text-left">{{ $t('使用数量') }}</th>
            <td class="text-left">
              <div class="input-group">
                <input
                  v-model.number="form.quantity"
                  type="number"
                  min="0"
                  class="form-control input"
                  :disabled="disabled"
                />
              </div>
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t('材料単価') }}</th>
            <td class="text-left">
              <div class="input-group">
                <input
                  v-model.number="form.purchasePrice"
                  type="number"
                  min="0"
                  class="form-control input"
                  :disabled="disabled"
                />
                <div class="input-group-append">
                  <span class="input-group-text">{{ $t('円') }}</span>
                </div>
              </div>
            </td>
            <th class="table-active text-left">{{ $t('手配リードタイム') }}</th>
            <td class="text-left">
              <div class="input-group">
                <input
                  v-model.number="form.materialLeadTime"
                  type="number"
                  min="0"
                  class="form-control input"
                  :disabled="disabled"
                />
                <div class="input-group-append">
                  <span class="input-group-text">{{ $t('日') }}</span>
                </div>
              </div>
            </td>
            <th class="table-active text-left">{{ $t('重量') }}</th>
            <td class="text-left">
              <div class="input-group">
                <input
                  v-model.number="form.shapeWeight"
                  type="number"
                  min="0"
                  class="form-control input"
                  :disabled="disabled"
                />
                <div class="input-group-append">
                  <span class="input-group-text">{{ $t('kg') }}</span>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t('材料備考') }}</th>
            <td class="text-left" colspan="99">
              <input
                v-model="form.note"
                type="text"
                class="form-control"
                :disabled="disabled"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </b-container>
    <template v-slot:modal-footer>
      <p class="text-danger text-center" v-if="error">{{ error }}</p>
      <div class="d-flex justify-content-center align-items-center mt-4 mb-4 w-100">
        <button
          type="button"
          class="btn btn-success mr-3 d-flex align-items-center justify-content-center"
          :disabled="registering"
          @click="register()"
        >
          <div
            class="d-flex justify-content-center align-items-center mr-3"
            v-if="registering"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </div>
          {{ $t('登録') }}
        </button>
        <button
          type="button"
          class="btn btn-light"
          :disabled="registering"
          @click="modalClose()"
        >{{ $t('キャンセル') }}</button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
const form = {
  type: 'material',
  code: '',
  name: '',
  isRoHS: false,
  quantity: null,
  materialLeadTime: null,
  note: '',
  shapeType: 'round',
  shapeValues: [],
  shapeWeight: null,
  purchasePrice: null,
}
export default {
  props: {
    productId: {
      type: Number,
    },
  },
  data() {
    return {
      form: {
        type: 'material',
        code: '',
        name: '',
        isRoHS: false,
        quantity: null,
        materialLeadTime: null,
        note: '',
        shapeType: 'round',
        shapeValues: [],
        shapeWeight: null,
        purchasePrice: null,
      },
      error: '',
      registering: false,
      disabled: false,
      materials: [],
    }
  },
  methods: {
    // モーダルを開いたときの処理
    async modalOpen(item) {
      try {
        this.$refs.materialShapeModal.show()
        if (item.id) {
          this.form = this.mixin_deepcopy(item)
          this.disabled = true
        } else {
          this.shapeTypeChange()
        }
      } catch (e) {
        // Do nothing
      }
    },
    // モーダルを閉じるときの処理
    modalClose() {
      this.$emit('modalClose')
      this.$refs.materialShapeModal.hide()
      this.form = this.mixin_deepcopy(form)
      this.disabled = false
    },
    // 製品寸法が変更されたらそれにともなって製品寸法の値の数を変更
    shapeTypeChange() {
      if (this.form.shapeType === 'round') {
        this.form.shapeValues = [0, 0]
      } else if (
        this.form.shapeType == 'corner' ||
        this.form.shapeType == 'plate'
      ) {
        this.form.shapeValues = [0, 0, 0]
      } else {
        this.form.shapeType = []
      }
    },
    // 既存の製品を選んだ時のその製品を代入する処理
    existMaterial(item) {
      this.form = this.mixin_deepcopy(item)
      this.disabled = true
    },
    // 選択解除のボタンを押下した時のid削除
    disabledRelease() {
      if (this.disabled) delete this.form.id
      this.disabled = false
      this.form.type = 'material'
    },
    // 登録処理
    async register() {
      if (!this.form.code)
        return (this.error = this.$t('材料コード') + this.$t('必須メッセージ'))
      this.registering = true
      let params = {}
      if (this.form.id) {
        params.id = this.form.id
      } else {
        for (let key of Object.keys(this.form)) {
          if (key === 'partners' || key === 'prices') {
            // Do nothing
          } else {
            params[key] = this.form[key]
          }
        }
        params.code = this.form.code

        for (let key of Object.keys(params)) {
          if (params[key] === null) {
            delete params[key]
          }
        }
      }
      params.parentProductId = this.productId
      let url = this.form.id
        ? `${this.$appConfig.CommonApiUrl}/product/material`
        : `${this.$appConfig.CommonApiUrl}/product`
      try {
        await this.$axios({
          method: 'post',
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
          url: url,
          data: params,
        })
        this.$emit('registered')
        this.$refs.materialShapeModal.hide()
        this.form = this.mixin_deepcopy(form)
        this.$toasted.success(this.$t('材料を登録しました。'))
        this.disabled = false
      } catch (error) {
        this.$toasted.show(this.$t('データ登録エラーメッセージ'))
      }
      this.registering = false
    },
  },
  computed: {
    filterCode() {
      return this.materials.filter(item => item.id !== this.productId)
    },
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
  watch: {
    'form.code': async function(newVal) {
      const params = {}
      params['type'] = 'material'
      if (newVal) {
        params['code'] = newVal
      }
      if (this.form.id !== null) {
        params['id'] = this.form.id
      }
      this.materials = await this.mixinGetAPI(
        `${this.$appConfig.CommonApiUrl}/products`,
        params,
      )
    },
  },
}
</script>
